import React from 'react';
import { Box } from '@mui/system';


interface RedDot {
    condition: boolean;
}


export const RedDot: React.FC<RedDot> = ({ condition }) => (
    <Box
        sx={{
            position: 'absolute',
            left: 'calc(50% - 2px)',
            backgroundColor: condition ? 'grayscale.shade0' : 'general.primary50',
            borderRadius: '50%',
            width: '4px',
            height: '4px',
        }}
    />
);
